// source-url — local validation of the "Source URL" field.
//
// Q-02 saw plain text ("hello", "youtube") reach POST /api/translations
// and come back as a raw `invalid_source_url` banner. The rule here is
// the same one the API applies first: it must parse as a URL and use
// http(s). Everything finer (is it a media page? is it reachable?) stays
// on the server, which knows the extractors.
//
// Pure module — unit-tested in node.

export type SourceUrlVerdict =
  | { ok: true; url: string }
  | { ok: false; reason: 'empty' | 'invalid' | 'scheme' };

export function validateSourceUrl(raw: string): SourceUrlVerdict {
  const url = raw.trim();
  if (!url) return { ok: false, reason: 'empty' };
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return { ok: false, reason: 'invalid' };
  }
  if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
    return { ok: false, reason: 'scheme' };
  }
  // `new URL('http://hello')` parses; a host without a dot is never a
  // media link and is exactly the "typed some words" case we gate.
  if (!parsed.hostname.includes('.') && parsed.hostname !== 'localhost') {
    return { ok: false, reason: 'invalid' };
  }
  return { ok: true, url };
}

/** i18n key for a failed verdict. */
export function sourceUrlErrorKey(reason: 'empty' | 'invalid' | 'scheme'): string {
  return reason === 'empty' ? 'urlRequired' : 'urlInvalid';
}
